import FileIcon from "common/components/FileUploader/FileIcon";
import type { StrapiFile } from "types";

type Props = {
  file?: StrapiFile;
};

function FileLabel({ file }: Props) {
  if (!file) return <span>-</span>;

  return (
    <div className="flex items-center gap-2">
      <FileIcon ext={file.ext} className="w-5 h-5 shrink-0" />
      <span className="text-sm truncate max-w-[200px]" title={file.caption || file.name}>
        {file.caption || file.name}
      </span>
    </div>
  );
}

export default FileLabel;
